import isNil from 'lodash-es/isNil'
import omitBy from 'lodash-es/omitBy'

import { isImageFile } from '../../../../utils/file'
import { toFailedFileListItem } from '../../File.utils'

import {
  REACT_DROPZONE_ERROR_TOO_LARGE,
  REACT_DROPZONE_ERROR_TOO_MANY,
} from './useFileDropzone.constants'

export function isReactDropzoneErrorTooMany(error) {
  return error === REACT_DROPZONE_ERROR_TOO_MANY
}

export function isReactDropzoneErrorTooLarge(error) {
  return error === REACT_DROPZONE_ERROR_TOO_LARGE
}

export function validateFiles(files) {
  return files.reduce(
    (acc, file) => {
      if (file?.id && !file.error) {
        return { ...acc, acceptedFiles: [...acc.acceptedFiles, file] }
      }

      if (!file?.id || file.error) {
        return { ...acc, rejectedFiles: [...acc.rejectedFiles, file] }
      }

      return acc
    },
    { acceptedFiles: [], rejectedFiles: [] }
  )
}

export function toFileListItem(file) {
  return new Promise(resolve => {
    const fileData = {
      id: file.name,
      mime_type: file.type,
      name: file.name,
      origin: [file],
      size: file.size,
      type: 0,
      uploading: true,
    }

    if (isImageFile(file)) {
      const img = new Image()
      const objectUrl = URL.createObjectURL(file)

      img.onload = () => {
        resolve(
          omitBy(
            {
              ...fileData,
              height: img.height,
              width: img.width,
            },
            isNil
          )
        )

        URL.revokeObjectURL(objectUrl)
      }

      img.src = objectUrl
    } else {
      resolve(omitBy(fileData, isNil))
    }
  })
}

// Guard for a custom `getFiles` that rejects as a whole
export function toFailedFileListItems(files, rejection) {
  return files.map(file => toFailedFileListItem(file, rejection))
}
